export const PLATFORM_ADMIN = 'platform_admin'
export const HUB_ADMIN = 'hub_admin'
export const SITE_ADMIN = 'site_admin'
export const PROJECT_ADMIN = 'project_admin'
